import { Rocket } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export default function Stub({ title, subtitle, testid = "stub-page" }) {
  return (
    <div data-testid={testid} className="max-w-2xl mx-auto py-6">
      <Card className="border-dashed border-2 border-neutral-200 rounded-2xl">
        <CardContent className="p-8 flex flex-col items-center text-center gap-3">
          <div className="h-14 w-14 rounded-2xl tulsi-gradient text-white flex items-center justify-center">
            <Rocket className="h-6 w-6" />
          </div>
          <h2 className="text-xl font-bold tracking-tight text-neutral-900">{title}</h2>
          <p className="text-sm text-neutral-500 max-w-md">{subtitle || "Coming in a future phase. This section is a placeholder to confirm role-aware navigation is working."}</p>
        </CardContent>
      </Card>
    </div>
  );
}
